import { Routes } from '@angular/router';

export const EXAMPLES_ROUTES: Routes = [
    {
        path: 'examples',
        title: 'Examples',
        data: {
            module: 'EXAMPLES',
        },
        children: [
            {
                path: 'form',
                children: [
                    {
                        path: 'add',
                        title: 'Add Example',
                        loadComponent: () => import('./form/example-add/example-add.component').then(m => m.ExampleAddComponent),
                    },
                    {
                        path: ':id/edit',
                        title: 'Edit Example',
                        loadComponent: () => import('./form/example-edit/example-edit.component').then(m => m.ExampleEditComponent),
                    },
                    {
                        path: '',
                        redirectTo: 'add',
                        pathMatch: 'full'
                    }
                ]
            },
            {
                path: '',
                redirectTo: 'form',
                pathMatch: 'full'
            }
        ]
    }
];
